import { render, staticRenderFns } from "./FormDesign.vue?vue&type=template&id=3759428b&scoped=true"
import script from "./FormDesign.vue?vue&type=script&lang=js"
export * from "./FormDesign.vue?vue&type=script&lang=js"
import style0 from "./FormDesign.vue?vue&type=style&index=0&id=3759428b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3759428b",
  null
  
)

export default component.exports